<label
  class="pr-input"
  [ngClass]="{ 'pr-input-state': !isDefault, 'pr-input-disabled': disabled }"
>
  @if (label) {
    <span class="pr-input-label d-flex"
      >{{ label }}
      @if (
        required ||
        (control &&
          control.validator &&
          control.validator({}) &&
          control.validator({}).required)
      ) {
        <em> *</em>
      }
      @if (tooltipButton) {
        <pr-icon
          class="tooltip-icon"
          name="sp-tooltip-icon"
          width="16"
          viewBoxWidth="18"
          viewBoxHeight="18"
          [tooltip]="tooltipButton"
        ></pr-icon>
      }
    </span>
  }
  <span
    class="pr-input-control"
    [ngClass]="{
      'is-invalid': derrors && control?.errors,
      'has-value': highlightOnValue && hasValue,
      'has-focus': highlightOnFocus && hasFocus,
    }"
    prLoader
    [loading]="loading"
    (focusin)="hasFocus = true"
    (focusout)="hasFocus = false"
  >
    <ng-content></ng-content>
    <span
      #suffixTemplate
      class="pr-input-suffix"
      [ngClass]="{ hide: suffixTemplate.children.length == 0 }"
    >
      <ng-content select="[suffix]"></ng-content>
    </span>
    @if (suffix && suffixTemplate.children.length == 0) {
      <span class="pr-input-suffix">{{ suffix }}</span>
    }
    <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
  </span>
</label>
